import { render, staticRenderFns } from "./zh_meiyitong.vue?vue&type=template&id=45cb2e0b&"
import script from "./zh_meiyitong.vue?vue&type=script&lang=js&"
export * from "./zh_meiyitong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports